// extracted by mini-css-extract-plugin
export default {"container":"installment_container__GLNvv","box":"installment_box__eNeSv","boxDark":"installment_boxDark__jmhOf"};